import React from "react";
import ConfirmationModal from "../../../components/ConfirmationModal";
import QrcodeModal from "../../../components/QrcodeModal";
import WhatsAppModal from "../../../components/WhatsAppModal";
import WhatsAppOficialModal from "../../../components/WhatsAppOficialModal";
import WhatsAppFacebookModal from "../../../components/WhatsAppFacebookModal";
import ReconnectProgressModal from "../../../components/ReconnectProgressModal";
import DisconnectProgressModal from "../../../components/DisconnectProgressModal";
import DeleteWhatsAppModal from "../../../components/DeleteWhatsAppModal";

const ConnectionModals = ({
  // ConfirmationModal
  confirmModalInfo,
  confirmModalOpen,
  onCloseConfirmModal,
  onDisconnectWhatsApp,
  onDeleteWhatsApp,
  // QrcodeModal
  qrModalOpen,
  onCloseQrModal,
  selectedWhatsApp,
  whatsAppModalOpen,
  // WhatsAppModal
  onCloseWhatsAppModal,
  onSaveWhatsApp,
  newConnectionProvider,
  // ReconnectProgressModal
  reconnectModalOpen,
  setReconnectModalOpen,
  setReconnectingWhatsApp,
  reconnectingWhatsApp,
  // DisconnectProgressModal
  disconnectModalOpen,
  setDisconnectModalOpen,
  setDisconnectingWhatsApp,
  disconnectingWhatsApp,
  // DeleteWhatsAppModal
  deleteModalOpen,
  setDeleteModalOpen,
  setDeletingWhatsApp,
  deletingWhatsApp,
  onCompleteDelete,
  onDeleteComplete,
}) => {
  // WABA (Meta Cloud API oficial) usa un modal DEDICADO; el clásico queda para Baileys/Evolution.
  const isWaba =
    selectedWhatsApp?.provider === "waba" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "waba");

  // Facebook Messenger / Instagram: modal dedicado propio (0373 FB1). Un flag por canal para el provider.
  const isFacebook =
    selectedWhatsApp?.provider === "facebook" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "facebook");
  // La primera rama —EDITAR una conexión de Instagram ya existente— es la que sigue en uso.
  // La segunda (alta nueva) quedó inerte al retirar del menú el "Instagram vía Facebook":
  // hoy Instagram entra solo por Business Login, que no pasa por este modal. Se conserva
  // para no cerrar la puerta si el alta manual vuelve a ofrecerse.
  const isInstagram =
    selectedWhatsApp?.provider === "instagram" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "instagram");
  const isFacebookLike = isFacebook || isInstagram;

  return (
  <>
    <ConfirmationModal
      title={confirmModalInfo.title}
      open={confirmModalOpen}
      onClose={onCloseConfirmModal}
      onConfirm={confirmModalInfo.action === "disconnect" ? onDisconnectWhatsApp : onDeleteWhatsApp}
    >
      {confirmModalInfo.message}
    </ConfirmationModal>
    <QrcodeModal
      open={qrModalOpen}
      onClose={onCloseQrModal}
      whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
    />
    <WhatsAppModal
      open={whatsAppModalOpen && !isWaba && !isFacebookLike}
      onClose={onCloseWhatsAppModal}
      whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
      defaultProvider={newConnectionProvider}
    />
    <WhatsAppOficialModal
      open={whatsAppModalOpen && isWaba}
      onClose={onCloseWhatsAppModal}
      whatsAppId={selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
    />
    <WhatsAppFacebookModal
      open={whatsAppModalOpen && isFacebookLike}
      onClose={onCloseWhatsAppModal}
      whatsAppId={selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
      provider={isInstagram ? "instagram" : "facebook"}
    />
    <ReconnectProgressModal
      open={reconnectModalOpen}
      onClose={() => {
        setReconnectModalOpen(false);
        setReconnectingWhatsApp(null);
      }}
      whatsAppName={reconnectingWhatsApp?.name || "WhatsApp"}
      whatsAppId={reconnectingWhatsApp?.id}
    />
    <DisconnectProgressModal
      open={disconnectModalOpen}
      onClose={() => {
        setDisconnectModalOpen(false);
        setDisconnectingWhatsApp(null);
      }}
      whatsAppName={disconnectingWhatsApp?.name || "WhatsApp"}
    />
    <DeleteWhatsAppModal
      open={deleteModalOpen}
      onClose={() => {
        setDeleteModalOpen(false);
        setDeletingWhatsApp(null);
      }}
      whatsAppName={deletingWhatsApp?.name || "WhatsApp"}
      whatsAppId={deletingWhatsApp?.id}
      onConfirm={onCompleteDelete}
      onDeleteComplete={onDeleteComplete}
    />
  </>
  );
};

export default ConnectionModals;
